import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, LocPortal } from '@cm/core/localization';

const pathStart = 'Share|Transcripts|Actions|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	feature: HubFeature.ShareTranscriptSendEmails,
	htmlAllowed: false,
	portal: 'CP' as LocPortal,
};

export type CPTranscriptActionsLocNames =
	| 'CPTranscriptActionsButtonEmailTranscript'
	| 'CPTranscriptActionsNotificationEmailSentSuccess'
	| 'CPTranscriptActionsNotificationEmailSentError';

export const cpTranscriptActionsLocs: LocDefs<CPTranscriptActionsLocNames> = {
	CPTranscriptActionsButtonEmailTranscript: {
		defaultValue: 'Email Transcript',
		description: 'Button label for emailing a transcript',
		displayPath: `${pathStart}Email Transcript Button`,
		displayType: 'Button',
		...sharedProperties,
	},
	CPTranscriptActionsNotificationEmailSentSuccess: {
		defaultValue: 'Transcript email sent successfully',
		description: 'Success notification when transcript email is sent',
		displayPath: `${pathStart}Email Sent Success Notification`,
		displayType: 'Notification',
		...sharedProperties,
	},
	CPTranscriptActionsNotificationEmailSentError: {
		defaultValue: 'Failed to send transcript email. Please try again.',
		description: 'Error notification when transcript email fails to send',
		displayPath: `${pathStart}Email Sent Error Notification`,
		displayType: 'Notification',
		...sharedProperties,
	},
};

export type CPTranscriptActionsLocType = LocMap<CPTranscriptActionsLocNames>;
